export const siteContent = {
  companyName: "CryPT-BR",
  tagline: "Brazil's Web3 PR Gateway",
  hero: {
    title: "Your Web3 PR Hub in LATAM",
    subtitle: "We turn your announcements into real visibility across leading crypto media outlets.",
    cta1: "Telegram",
    cta2: "Email",
    note: "Need a quick reply? Chat with us on Telegram"
  },
  about: {
    title: "About Us",
    paragraphs: [
      "CryPT-BR helps Web3 projects break into LATAM's fast-growing crypto market.",
      "Through strategic press release distribution and localized storytelling, we ensure your announcements reach the right audience at the right time.",
      "We connect your project with LATAM crypto media, investors, builders, and communities — turning news into visibility, authority, and lasting impact."
    ]
  },
  mediaCoverage: {
    title: "Trusted Media Coverage for Your Project",
    description: "From press releases and sponsored articles to organic PR campaigns, we manage everything from development to guaranteed placement across key media outlets"
  },
  services: [
    {
      id: 1,
      title: "Targeted Media Distribution",
      description: "Strategic distribution across Brazil's top crypto media outlets to ensure your message reaches the right audience with maximum impact."
    },
    {
      id: 2,
      title: "Localised Messaging",
      description: "Culturally-adapted content that resonates with Brazilian audiences, combining global crypto trends with local market insights."
    },
    {
      id: 3,
      title: "Community Exposure",
      description: "Direct access to Brazil's engaged Web3 communities, connecting your project with investors, builders, and early adopters."
    },
    {
      id: 4,
      title: "Blockchain-Focused PR",
      description: "Specialized PR strategies tailored for blockchain projects, DeFi protocols, NFT launches, and Web3 innovations in the Brazilian market."
    },
    {
      id: 5,
      title: "Shareable Micro Press Assets",
      description: "High-impact, 30–40 second fully customized short videos designed for native distribution across X and social platforms."
    },
    {
      id: 6,
      title: "Banner Ads Placement",
      description: "Targeted banner advertising on premium Brazilian Web3, crypto, and blockchain platforms to drive traffic, visibility, and brand recognition."
    }
  ],
  mediaPartners: [
    { name: "Cointelegraph Brasil", logo: "https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/f1s46mxy_ctbr.svg" },
    { name: "Portal do Bitcoin", logo: "https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/dafxe7zo_Portal%20do%20Bitcoin.webp" },
    { name: "Bitcoin Block", logo: "https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/1kwab85t_Bitcoin%20Block.webp" },
    { name: "TechCripto", logo: "/images/techcripto.png" },
    { name: "SpaceMoney", logo: "https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/vimcp1df_Spacemoney.svg" },
    { name: "Bitnoticias", logo: "https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/cv6n05j8_Bitnoticias.webp" },
    { name: "Webitcoin", logo: "https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/mf13td2o_Webitcoin.PNG" },
    { name: "CryptoID", logo: "https://customer-assets.emergentagent.com/job_cryptbr-promo/artifacts/35bcktw0_CryptoID.png" },
    { name: "CriptoTendencia", logo: "https://customer-assets-agu9un31.emergentagent.net/job_7765c863-1abb-4263-991c-711fd7c104cd/artifacts/d0468129856791c8_ct%20cripto%20tend.png" },
    { name: "CriptoInforme", logo: "https://customer-assets-agu9un31.emergentagent.net/job_7765c863-1abb-4263-991c-711fd7c104cd/artifacts/294a8d541b761a11_ct%20criptoinforme.webp" },
    { name: "CriptoNoticias", logo: "https://customer-assets-agu9un31.emergentagent.net/job_7765c863-1abb-4263-991c-711fd7c104cd/artifacts/3d1e0b7a6a47046a_ct%20criptonoticias.webp" },
    { name: "DiarioBitcoin", logo: "https://customer-assets-agu9un31.emergentagent.net/job_7765c863-1abb-4263-991c-711fd7c104cd/artifacts/36e590a3ac95e772_ct%20diariobitcoin-logo-full-whitefg.png" },
    { name: "CoinTelegraph ES", logo: "https://customer-assets-agu9un31.emergentagent.net/job_7765c863-1abb-4263-991c-711fd7c104cd/artifacts/4d7114508ba65e56_ct%20es.png" }
  ],
  contact: {
    telegram: "https://t.me/Quesho89",
    email: "marketing@cryptbr.com",
    linkedinPersonal: "https://www.linkedin.com/company/crypt-br/",
    twitter: "https://x.com/cryptbrmkt"
  },
  footer: {
    year: new Date().getFullYear(),
    links: [
      { name: "Privacy Policy", url: "#privacy" },
      { name: "Legal", url: "#legal" },
      { name: "Cookies Policy", url: "#cookies" }
    ]
  }
};